import Alpine from "alpinejs";
import axios from "axios";


document.addEventListener('alpine:init', () => {
    Alpine.data('finance', (key, price, make, model, year) => ({
        objectPrice: price,

        downpayment: 1,
        term: 4,
        downpaymentMap: ['0%', '20%', '30%', '40%'],
        downpaymentValues: [0, 0.2, 0.3, 0.4],
        termMap: ['48 mdr.', '60 mdr.', '72 mdr.', '84 mdr.', '96 mdr.'],
        termValues: [48, 60, 72, 84, 96],

        finance: null,

        init() {
            this.calculate()
        },

        calculate() {
            var downPayment = this.objectPrice * this.downpaymentValues[this.downpayment];

            var calcModel = {
                ObjectPrice: this.objectPrice,
                DownPayment: downPayment,
                PaymentTerms: this.termValues[this.term],
                PartnerExternalDealerId: key,
                Make: make,
                Model: model,
                ModelYear: year
            }

            axios.post("https://api.scb.nu/SCBDK.Dealer.ExternalCalc/v2/api/Calculator", calcModel).then(res => {
                this.finance = res.data
            }).catch(err => {
                alert("Der opstod en fejl!")
            })
        },
        application() {
            const newWindow = window.open('', '_blank');

            var applyModel = {
                ObjectPrice: this.finance.ObjectPrice,
                DownPayment: this.finance.DownPayment,
                PaymentTerms: this.finance.PaymentTerms,
                PartnerExternalDealerId: key,
                Make: make,
                Model: model,
                ModelYear: year,

                Url: window.location.href,
                CorrelationId: this.finance.CorrelationId
            }

            axios.post("https://api.scb.nu/SCBDK.Dealer.ExternalCalc/v2/api/Application", applyModel).then(res => {
                if (res.data.HasError) {
                    newWindow.close(); // Luk vinduet hvis der er fejl
                    alert(res.data.ErrorMessage)
                } else {
                    newWindow.location.href = res.data.RedirectUrl; // Naviger vinduet til URL'en
                }
            }).catch(err => {
                newWindow.close(); // Luk hvis request fejler
                alert("Noget gik galt med ansøgningen.");
            });
        },


        formatNumber(number, defaultVal, append) {
            if (number == null) {
                return defaultVal + append
            }

            return new Intl.NumberFormat('da-DK', { minimumFractionDigits: 0 }).format(number) + append
            //return new Intl.NumberFormat('da-DK', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(number);
        }
    }))
});
